/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GroupDefs from '../group/defs.defs.js'

const $nsid = 'chat.bsky.embed.joinLink'

export { $nsid }

type Main = {
  $type?: 'chat.bsky.embed.joinLink'

  /**
   * The join link code.
   */
  code: string
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({ code: /*#__PURE__*/ l.string() }),
)

export { main }

export const $type = $nsid
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'chat.bsky.embed.joinLink#view'
  joinLinkPreview:
    | l.$Typed<GroupDefs.JoinLinkPreviewView>
    | l.$Typed<GroupDefs.DisabledJoinLinkPreviewView>
    | l.$Typed<GroupDefs.InvalidJoinLinkPreviewView>
    | l.Unknown$TypedObject
}

export type { View }

const view = /*#__PURE__*/ l.typedObject<View>(
  $nsid,
  'view',
  /*#__PURE__*/ l.object({
    joinLinkPreview: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<GroupDefs.JoinLinkPreviewView>(
          (() => GroupDefs.joinLinkPreviewView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GroupDefs.DisabledJoinLinkPreviewView>(
          (() => GroupDefs.disabledJoinLinkPreviewView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GroupDefs.InvalidJoinLinkPreviewView>(
          (() => GroupDefs.invalidJoinLinkPreviewView) as any,
        ),
      ],
      false,
    ),
  }),
)

export { view }
